var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagSouthAfrica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16512)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68622 27.3245C-1.56215 21.0761 -1.56215 10.9455 4.68622 4.69702C4.68578 4.69771 13.913 16.0108 13.913 16.0108L4.68622 27.3245Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.913 16.0107L2.12204 8.04272C1.75648 8.67816 1.4341 9.34141 1.1571 10.0279L7.12642 16.0107L1.15729 21.9938C1.43404 22.6798 1.7561 23.3427 2.12142 23.9777L13.913 16.0107Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8642 13.9238H13.9123L4.68578 4.69727C3.69153 5.69152 2.82772 6.81595 2.12172 8.04289L10.0742 16.0108L2.12109 23.9776C2.82709 25.2049 3.69128 26.3297 4.68578 27.3242L13.9123 18.0977H31.8642C31.9532 17.4146 31.9997 16.7181 31.9997 16.0108C31.9997 15.3035 31.9532 14.607 31.8642 13.9238Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25861 28.7029C8.95667 30.7768 12.334 32.0106 16 32.0106C23.3924 32.0106 29.6128 26.9968 31.4488 20.1846H14.777L6.25861 28.7029Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4488 11.8368C29.6128 5.02455 23.3924 0.0107422 16 0.0107422C12.334 0.0107422 8.95667 1.24455 6.25861 3.31843L14.777 11.8368H31.4488Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16512"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSouthAfrica);
export default __webpack_public_path__ + "static/media/flag_south_africa.a211822d97149bbcb3376f5cd6779c58.svg";
export { ForwardRef as ReactComponent };